import { createContext } from 'react'

import { FormValidation, FormValidationAction } from '@Shared/Components/Forms/FormElement.types'

export interface FormContextProps<T> {
  blurElement: () => void
  model: T
  setActiveID: (id: string) => void
  submitAttempts: number
  updateModel: (model: T) => void
  updateValidationFunctions: (key: string, fn: Function) => void
  updateValidationResults: (key: string, validationResults: FormValidation) => void
  validateOn?: FormValidationAction
  validationResults: Record<keyof T | string, FormValidation>
}
export const FormContext = createContext<FormContextProps<{}>>({} as FormContextProps<{}>)
